@for (error of errors; track $index) {
  <p-message severity="error" size="small" variant="simple">
    {{ error.key | translate:error.params }}
  </p-message>
}